// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8-cit","input":"styles_input__2shHB"};